var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-options",on:{"mouseleave":_vm.handleMouseleave}},[(_vm.isShow)?_c('b-button-group',{attrs:{"vertical":""}},[_c('b-button',{attrs:{"variant":"options"},on:{"click":_vm.reply}},[_vm._v("Reply")]),_c('b-button',{attrs:{"variant":"options"},on:{"click":_vm.hide}},[_vm._v("Close")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }